import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BillingContext = createContext({ billing: null, refresh: () => {} });
export const useBilling = () => useContext(BillingContext);

export function BillingProvider({ children }) {
  const { user } = useAuth();
  const [billing, setBilling] = useState(null);
  const navigate = useNavigate();

  const refresh = useCallback(async () => {
    try { const { data } = await api.get("/billing/status"); setBilling(data); } catch { /* signed out */ }
  }, []);

  useEffect(() => { if (user) refresh(); else setBilling(null); }, [user, refresh]);

  useEffect(() => {
    const onTask = () => refresh();
    const onPaywall = (e) => {
      refresh();
      const quota = typeof e.detail === "string" && e.detail.includes("800");
      toast.error(quota ? "You've used this month's 800 tasks" : "Your free tasks are used", {
        id: "paywall",
        description: quota ? "Refill 800 tasks for ₹85 to keep going." : "Subscribe for ₹85/month (800 tasks) to keep dictating. Your history stays available.",
        action: { label: quota ? "Refill" : "Subscribe", onClick: () => navigate("/billing") },
      });
    };
    window.addEventListener("mulankan:task", onTask);
    window.addEventListener("mulankan:paywall", onPaywall);
    return () => { window.removeEventListener("mulankan:task", onTask); window.removeEventListener("mulankan:paywall", onPaywall); };
  }, [refresh, navigate]);

  return <BillingContext.Provider value={{ billing, refresh, setBilling }}>{children}</BillingContext.Provider>;
}
